module.exports = __webpack_public_path__ + "img/client_administrateurs.9b0205bb.png";